export const socialLinks = [
  {
    name: 'Facebook',
    icon: '/static/images/social/v2/facebook.svg',
    hoverIcon: '/static/images/social/v2/facebook-color.svg',
    url: 'https://facebook.com/pages/1-800-Accountant/226537857441736',
  },
  {
    name: 'Twitter',
    icon: '/static/images/social/v2/twitter.svg',
    hoverIcon: '/static/images/social/v2/twitter-color.svg',
    url: 'https://twitter.com/1800Accountant',
  },
  {
    name: 'Instagram',
    icon: '/static/images/social/v2/instagram.svg',
    hoverIcon: '/static/images/social/v2/instagram-color.svg',
    url: 'https://www.instagram.com/1.800accountant/?hl=en',
  },
  {
    name: 'LinkedIn',
    icon: '/static/images/social/v2/linkedin.svg',
    hoverIcon: '/static/images/social/v2/linkedin-color.svg',
    url: 'https://linkedin.com/company/1800-accountant',
  },
  {
    name: 'Youtube',
    icon: '/static/images/social/v2/youtube.svg',
    hoverIcon: '/static/images/social/v2/youtube-color.svg',
    url: 'https://www.youtube.com/c/1800accountant',
  },
];
